// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.page{background:#fff;padding:var(--uap-page-padding)}.page-content{width:clamp(0px,100%,var(--uap-page-max-width));margin:0 auto;display:flex;flex-direction:column;gap:var(--uap-spacing-between-sections)}@media(width >= 1024px){.page-table{padding:var(--uap-page-upgrade-table-padding)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
